import React, { useEffect } from 'react';
import { useState } from 'react'
import Footer from "../../MyComponents/Footer";
// import GuestNav from "../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../MyComponents/Hero2";
import heroContent from './HeroContent';
import leftimgs from "../../assets/designleftimg.png";
import rightimgs from "../../assets/designrightimg.png";
// import adobe from "../../assets/adobeimg.png"
// import corel from "../../assets/corelimg.png"
// import photoshop from "../../assets/photoshopimg.png"
// import canva from "../../assets/canvaimg.png"
// import illustrator from "../../assets/illustratorimg.png"
// import threeD from "../../assets/3dimg.png"
// import figma from "../../assets/figmaimg.png"
// import CourseExplorer from '../../MyComponents/CourseExplorer';
import LearningStyle from '../../MyComponents/LearningStyle';
import Testimonials from '../../MyComponents/Testimonials';
import FAQs from '../../MyComponents/FooterPages/newfaq';
import HeadSection from "../HeadSection.js";
import pencilIcon from "../../assets/pencil.png";
import API_CONFIG from "../../config/api";
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import { Link } from "react-router-dom";
// import img1 from "../../assets/Design Courses/1 (16).png"
// import img2 from "../../assets/Design Courses/1 (17).png"
// import img3 from "../../assets/Design Courses/1 (18).png"
// import img4 from "../../assets/Design Courses/1 (62).png"
// import img5 from "../../assets/Design Courses/1 (63).png"
// import img6 from "../../assets/Design Courses/1 (64).png"
// import img7 from "../../assets/Design Courses/1 (65).png"

// import icon1 from "../../assets/Design Courses/1 (1).png"
// import icon2 from "../../assets/Design Courses/1 (14).png"
// import icon3 from "../../assets/Design Courses/1 (60).png"
// import icon4 from "../../assets/Design Courses/1 (66).png"
// import icon5 from "../../assets/Design Courses/1 (2).png"
// import icon6 from "../../assets/Design Courses/1 (54).png"
// import icon7 from "../../assets/Design Courses/1 (57).png"
import { Helmet } from "react-helmet";
const courses = [
  {
    title: "Adobe XD",
    image: "Polymath-images/Design Courses/1 (16).jpg",
    icon: "Polymath-images/Design Courses/adobe_xd_elements_logo.png",
    color: "#d4149aff",
    age: "Age: 12+",
    link: "/graphic_designing_adobexd"
  },
  {
    title: "Corel Draw",
    image: "Polymath-images/Design Courses/1 (17).jpg",
    icon: "Polymath-images/Design Courses/coreldraw_icon.png",
    color: "#9956bbff",
    age: "Age: 12+",
    link: "/graphic_designing_corel"
  },
  {
    title: "Photoshop",
    image: "Polymath-images/Design Courses/1 (18).jpg",
    icon: "Polymath-images/Design Courses/1 (60).jpg",
    color: "#66c0ccff",
    age: "Age: 12+",
    link: "/graphic_designing_photosh"
  },
  {
    title: "Canva",
    image: "Polymath-images/Design Courses/1 (62).jpg",
    icon: "Polymath-images/Design Courses/1 (66).jpg",
    color: "#1f7c08ff",
    age: "Age: 12+",
    link: "/graphic_designing_canva"
  },
  {
    title: "Illustrator",
    image: "Polymath-images/Design Courses/1 (63).jpg",
    icon: "Polymath-images/Design Courses/1 (2).png",
    color: "#ffde24ff",
    age: "Age: 12+",
    link: "/graphic_designing_illustr"
  },
  {
    title: "3D Modeling",
    image: "Polymath-images/Design Courses/1 (64).jpg",
    icon: "Polymath-images/Design Courses/1 (54).jpg",
    color: "#d4149aff",
    age: "Age: 12+",
    link: "/graphic_designing_3DModel"
  },
  {
    title: "Figma",
    image: "Polymath-images/Design Courses/1 (65).jpg",
    icon: "Polymath-images/Design Courses/1 (57).jpg",
    color: "#9956bbff",
    age: "Age: 12+",
    link: "/graphic_designing_figma"
  }


];
const GraphicPopularCourses = () => {
  const navigate = useNavigate();

  const handleBookDemoClick = () => {
    navigate("/BookADemo");
  };
  return (
    <>
      <Helmet>
        <title>Graphic Design Courses for Kids | Photoshop, Canva & More -- Polymath-Kids</title>
        <meta name="description" content="Polymath-Kids offers fun graphic design courses for kids. Learn Photoshop, Canva, Illustrator & more to boost creativity, problem-solving & visual skills." />
      </Helmet>

      <div className="stem-container">
        <h1 className="stem-title-1">Explore Our Fun & Skill-Boosting </h1>
        <h1 className="stem-title">Design Courses</h1>
        <div className="courses-grid">
          {courses.map((course) => (
            <div key={course.title} className="course-card">
              <Link to={course.link} className="course-link">

                <div className="course-image-container">
                  <img
                    src={`${API_CONFIG.IMAGES_URL}/${course.image}`}
                    alt={course.title}
                    className="course-image"
                  />
                  <span className="ages-badge">{course.age}</span>
                </div>

                <div className="icon-container" style={{ backgroundColor: course.color }}>
                  <img src={`${API_CONFIG.IMAGES_URL}/${course.icon}`} alt={`${course.title} icon`} className="course-icon" />
                </div>

                <p className="course-title">{course.title}</p>
              </Link>
            </div>
          ))}
        </div>
        <button className="pocustom-btn yellow-btn" onClick={handleBookDemoClick}>
          <img src={pencilIcon} alt="icon" className="pobtn-icon" />
          Book Free Demo Class
        </button>
      </div>
    </>
  );
};
const GraphicDesignPortal = () => {
  const designpage = heroContent.designpage;
  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
        leftImg={"Polymath-images/designleftimg.png"}
        rightImg={"Polymath-images/designrightimg.png"}
        titlePart1="Graphic Design Courses"
        titlePart2="That Spark Creativity"
        description="Graphic design is everywhere—from logos to websites—and it's a powerful way to communicate visually. Polymath-Kids’ courses make design fun and accessible for kids, helping them build creativity, problem-solving skills, and a strong foundation for future careers."
        button1Text={false}
        button2Text="Book Free Demo Class"
        button1Icon={'Polymath-images/pencil.png'}
        button2Icon={'Polymath-images/pencil.png'}
        onButton1Click={() => alert("Early bird discount clicked!")}
        onButton2Click={() => alert("Book demo clicked!")}
      />

      <GraphicPopularCourses />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
}
export default GraphicDesignPortal